/* * eleReady.js
 * A simple utility to execute a function when elements matching a selector are present in the DOM.
*/
(function (win) {
    "use strict";
    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;
    function ready(selector, fn) {
    // Store the selector and callback to be monitored
    listeners.push({
        selector: selector,
        fn: fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
        childList: true,
        subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
    }
    function check() {
    // Check the DOM for elements matching a stored selector
    for (
        var i = 0, len = listeners.length, listener, elements;
        i < len;
        i++
    ) {
        listener = listeners[i];
        // Query for elements matching the specified selector
        elements = doc.querySelectorAll(listener.selector);

        for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        // Make sure the callback isn't invoked with the
        // same element more than once
        if (!element.ready) {
            element.ready = "select";
            // Invoke the callback with the element
            listener.fn.call(element, element);
        }
        }
    }
    }
    win.eleReady = ready;
})(this);



function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}


/* START - Change raitting star text */
waitUntil(
  () =>
    document.querySelector(".rating-wrapper .RatingBarWidget__inner") &&
    document.querySelector(
      ".rating-wrapper .RatingBarWidget__inner .R-TextBody"
    )
).then(async () => {
  const reviewText = document
    .querySelector(".rating-wrapper .RatingBarWidget__inner .R-TextBody .cssVar-reviewText:last-child");

  reviewText.innerHTML = " store reveiws";

  const reviewDiv = document.querySelector(
    ".rating-wrapper .RatingBarWidget__inner .R-TextBody"
  );

  if (reviewDiv) {
    reviewDiv.addEventListener("click", () =>
      scrollToSection(".R-ReviewsList-container")
    );
  }
});
/* END - Change raitting star text */


/* START - Sticky quantity and add to cart button  */
waitUntil(
  () =>
    document.querySelector(".qty-container") &&
    document.querySelector(".ATC-container") &&
    document.querySelector(".qty-atc-subcontainer") &&
    document.querySelector(".CP-stock-status-wrapper")
).then(() => {
  
  const qtyContainer = document.querySelector(".qty-container");
  const addToCartContainer = document.querySelector(".ATC-container");
  const subContainer = document.querySelector(".qty-atc-subcontainer");
  const customTextContainer = document.querySelector(".qty-label-cont");

  const custom_qty_atc_Container = document.querySelector('.CP-atc-qty-container');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          custom_qty_atc_Container.classList.remove("sticky");
        } else {
          custom_qty_atc_Container.classList.add("sticky");
        }
      });
    },
    {
      root: null,
      threshold: 1,
    }
  );

  observer.observe(customTextContainer);
});

/* END - Sticky quantity and add to cart button  */


/* START - Hide social share text */
waitUntil(() => document.querySelector(".product__social-share")).then(
  async () => {
    const shareEl = document.querySelector(".product__social-share");
    if (shareEl && shareEl.parentElement.parentElement) {
      shareEl.parentElement.parentElement.style.display = "none";
    }
  }
);
/* END - Hide social share text */


/* START - USP POPUP */
waitUntil(() => document.querySelector(".list_box .item_container")).then(() => {
  const itemContainers = document.querySelectorAll(".list_box .item_container");

  itemContainers.forEach((item) => {
    item.addEventListener("click", () => {
      if (item.classList.contains("return_items_container")) {
        document.body.classList.add("CP-uspOpen");
        document.querySelector(".CP-returnpolicy-popup")?.classList.add("active");
      } else if (item.classList.contains("easypurchase_items_container")) {
        document.body.classList.add("CP-uspOpen");
        document.querySelector(".CP-deliver-popup")?.classList.add("active");
      }
    });
  });

  // Handle popup close
  document.querySelectorAll(".CP-popClose").forEach((closeBtn) => {
    closeBtn.addEventListener("click", () => {
      document.body.classList.remove("CP-uspOpen");
      document.querySelector(".CP-returnpolicy-popup")?.classList.remove("active");
      document.querySelector(".CP-deliver-popup")?.classList.remove("active");
    });
  });
  // Overlay click to close (only when clicking the overlay, not the inner popup)
  document.querySelectorAll(".CP-usp-overlay").forEach((overlay) => {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document.body.classList.remove("CP-uspOpen");
        document.querySelector(".CP-returnpolicy-popup")?.classList.remove("active");
        document.querySelector(".CP-deliver-popup")?.classList.remove("active");
      }
    });
  });
});
/* END - USP POPUP */


/* START - PDP Review Images Slider */
/*
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const cards = track.querySelectorAll(".CP-carousel-card");

  const firstClone = cards[0].cloneNode(true);
  const lastClone = cards[cards.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, track.firstChild);

  let currentIndex = 1;
  const totalCards = cards.length + 2;

  const updateCarousel = (smooth = true) => {
    const cardWidth = cards[0].offsetWidth + 20;
    const containerWidth = track.parentElement.offsetWidth;
    const offset = (containerWidth - cardWidth) / 2;
    const translateX = -currentIndex * cardWidth + offset;

    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle(
        "active",
        i === (currentIndex - 1 + cards.length) % cards.length
      );
    });
  };

  // Add dot indicators
  cards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1;
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = cards.length;
      updateCarousel(false);
    } else if (currentIndex === totalCards - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // Touch swipe
  let startX = 0;
  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    if (endX - startX > 50) {
      currentIndex--;
      updateCarousel();
    } else if (startX - endX > 50) {
      currentIndex++;
      updateCarousel();
    }
  });

  updateCarousel(false);
});

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const originalCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  const cardWidth = originalCards[0].offsetWidth;
  const containerWidth = track.parentElement.offsetWidth;
  const offset = (containerWidth - cardWidth) / 2;

  // Clone first and last card for infinite loop effect
  const firstClone = originalCards[0].cloneNode(true);
  const lastClone = originalCards[originalCards.length - 1].cloneNode(true);
  //track.appendChild(firstClone);
  //track.insertBefore(lastClone, track.firstChild);

  // Recalculate card list (now includes clones)
  const allCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  let currentIndex = 1; // Start at the "real" first slide

  const updateCarousel = (smooth = true) => {
    const translateX = -currentIndex * cardWidth + offset;
    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    // Update dots
    const dotIndex = (currentIndex - 1 + originalCards.length) % originalCards.length;
    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle("active", i === dotIndex);
    });
  };

  // Dot creation
  originalCards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1;
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  // Handle looping transition reset
  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = originalCards.length;
      updateCarousel(false);
    } else if (currentIndex === allCards.length - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // Swipe handling
  let startX = 0;
  let isSwiping = false;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isSwiping = true;
  });

  track.addEventListener("touchmove", (e) => {
    if (!isSwiping) return;
    const currentX = e.touches[0].clientX;
    const delta = currentX - startX;
    const translateX = -currentIndex * cardWidth + offset + delta;

    track.style.transition = "none";
    track.style.transform = `translateX(${translateX}px)`;
  });

  track.addEventListener("touchend", (e) => {
    if (!isSwiping) return;
    isSwiping = false;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (diff > 50) {
      currentIndex--;
    } else if (diff < -50) {
      currentIndex++;
    }
    updateCarousel();
  });

  updateCarousel(false); // Initial position
});
*/

/*
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const originalCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  const cardWidth = originalCards[0].offsetWidth;
  const containerWidth = track.parentElement.offsetWidth;
  const offset = (containerWidth - cardWidth) / 2;

  // ✅ Clone first and last card for infinite loop effect
  const firstClone = originalCards[0].cloneNode(true);
  const lastClone = originalCards[originalCards.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, track.firstChild);

  // ✅ Update allCards after cloning
  const allCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  let currentIndex = 1; // Start at first real card (after lastClone)

  const updateCarousel = (smooth = true) => {
    const translateX = -currentIndex * cardWidth + offset;
    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    // ✅ Adjust active dot
    const dotIndex = (currentIndex - 1 + originalCards.length) % originalCards.length;
    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle("active", i === dotIndex);
    });
  };

  // ✅ Create Dots
  originalCards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1; // +1 because of prepended lastClone
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  // ✅ Handle infinite loop reset
  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = originalCards.length;
      updateCarousel(false);
    } else if (currentIndex === allCards.length - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // ✅ Swipe logic
  let startX = 0;
  let isSwiping = false;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isSwiping = true;
  });

  track.addEventListener("touchmove", (e) => {
    if (!isSwiping) return;
    const currentX = e.touches[0].clientX;
    const delta = currentX - startX;
    const translateX = -currentIndex * cardWidth + offset + delta;

    track.style.transition = "none";
    track.style.transform = `translateX(${translateX}px)`;
  });

  track.addEventListener("touchend", (e) => {
    if (!isSwiping) return;
    isSwiping = false;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (diff > 50) {
      currentIndex--;
    } else if (diff < -50) {
      currentIndex++;
    }
    updateCarousel();
  });

  updateCarousel(false); // ✅ Initial position
});
*/

document.addEventListener("DOMContentLoaded", function () {
  const carouselSlider = new Swiper(".CP-carousel-container", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    pagination: {
      el: ".CP-carousel-dots",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
});

/* END - PDP Review Images Slider */


/* START - Click To Scroll */
const scrollToSection = (selector) => {
  const section = document.querySelector(selector);

  if (section) {
    if (section.classList.contains("return_policy")) {
      section.classList.add("open");
    } else if (section.classList.contains("productDetail")) {
      section.previousElementSibling.classList.add("open");
    }
    const offset = 170;
    const topPos =
      section.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: topPos,
      behavior: "smooth",
    });
  }
};

const mappings = [
  { trigger: ".CP-detail-box", target: ".productDetail" },
  { trigger: ".CP-review-box", target: ".R-ReviewsList-container" },
  { trigger: ".CP-product-box", target: "#similar-products" },
  // { trigger: ".CP-shipping-container", target: ".return_policy" },
  { trigger: ".CP-read-review", target: ".R-ReviewsList-container" },
];

mappings.forEach(({ trigger, target }) => {
  const el = document.querySelector(trigger);
  if (el) {
    el.addEventListener("click", () => scrollToSection(target));
  }
});
/* END - Click To Scroll */





/* START - Reel ka Feel */
waitUntil(
  () =>
    document.querySelector(".glow_card .care-info-sec-heading") &&
    document.querySelector(".glow_card .glow_video_cards_wrapper")
).then(() => {

  const glowCard = document.querySelector(".glow_card");

  eleReady(
    ".glow_card .glow_wrapper .glow_video_cards_wrapper",
    function (glowWrapper) {
      const navIconLeft = document.createElement("a");
      navIconLeft.className = "CP-video-prev";
      navIconLeft.innerHTML = "&#10094;";

      const navIconRight = document.createElement("a");
      navIconRight.className = "CP-video-next";
      navIconRight.innerHTML = "&#10095;";

      const parentWrapper = glowWrapper.parentElement;

      const oldPrev = parentWrapper.querySelector(".CP-video-prev");
      const oldNext = parentWrapper.querySelector(".CP-video-next");
      if (oldPrev) oldPrev.remove();
      if (oldNext) oldNext.remove();

      parentWrapper.appendChild(navIconLeft);
      parentWrapper.appendChild(navIconRight);

      const videoCards = glowWrapper.querySelectorAll(".glow_video_box");
      let cardWidth = 0;
      if (videoCards.length > 0) {  cardWidth = videoCards[0].offsetWidth;  }
      if (videoCards.length === 0) return;

      const url = [
        "https://itokri.com/collections/dharwad-stitched-suits",
        "https://itokri.com/collections/jacquard-kurtis",
        "https://itokri.com/collections/ajrakh-printed-stitched-suits",
        "https://itokri.com/collections/kalamkari-block-print-dresses",
        "https://itokri.com/collections/itokri-casuals",
      ];

      videoCards.forEach((div, index) => {
        const targetUrl = url[index] || "#";

        div.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          window.open(targetUrl, "_blank");
        });
      });

      navIconLeft.addEventListener("click", () => {
        console.log("click left");
        glowWrapper.scrollBy({
          left: -cardWidth,
          behavior: "smooth",
        });
      });

      navIconRight.addEventListener("click", () => {
        console.log("click right");
        glowWrapper.scrollBy({
          left: cardWidth,
          behavior: "smooth",
        });
      });


// Function to show/hide arrows based on scroll position
function updateArrowVisibility() {
  const scrollLeft = Math.round(glowWrapper.scrollLeft);
  const maxScrollLeft = glowWrapper.scrollWidth - glowWrapper.clientWidth;

  // Hide left arrow if fully scrolled to left
  const twoCardWidth = cardWidth;
  if ( scrollLeft <= twoCardWidth ) {
    navIconLeft.style.display = "none";
  } else {
    navIconLeft.style.display = "block";
  }

  // Hide right arrow if fully scrolled to right
  if (scrollLeft >= Math.round(maxScrollLeft) - 2) {
    navIconRight.style.display = "none";
  } else {
    navIconRight.style.display = "block";
  }
}

// Initial check
updateArrowVisibility();

// Re-check on scroll and resize
glowWrapper.addEventListener("scroll", updateArrowVisibility);
      
  });
});
/* END - Reels and Reviews */







/*
waitUntil(() => document.querySelector(".product-info-block")).then(() => {
  if (document.body.classList.contains("CP-product-info-open")) return;

  const contactButton = document.querySelector(".CP-contact-button");

  contactButton.addEventListener("click", async () => {
    if (document.querySelector(".CP-product-info-overlay")) return;

    const overlay = document.createElement("div");
    overlay.className = "CP-product-info-overlay";

    const popupContent = document.createElement("div");
    popupContent.className = "CP-product-info-popup";

    const closeBtn = document.createElement("a");
    closeBtn.className = "CP-popup-close-btn";
    closeBtn.innerHTML = "&#10006;";
    popupContent.appendChild(closeBtn);

    const productInfoBlock = document
      .querySelector(".product-info-block")
      .cloneNode(true);
    popupContent.appendChild(productInfoBlock);

    overlay.appendChild(popupContent);
    document.body.appendChild(overlay);
    document.body.classList.add("CP-product-info-open");

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document.body.classList.remove("CP-product-info-open");
        overlay.remove();
      }
    });

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.remove("CP-product-info-open");
      overlay.remove();
    });
  });
});
*/

